import style from "./Spinner.module.css";
import React from "react";

export const Spinner = () => (
  <div className={style.loading}> </div>
);